export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707986aecd5cdd726ea73d94f07f2606396d29e182&name=pushAdClickData!'